import { render, staticRenderFns } from "./dataBox2.vue?vue&type=template&id=fbff5254&scoped=true&"
import script from "./dataBox2.vue?vue&type=script&lang=ts&"
export * from "./dataBox2.vue?vue&type=script&lang=ts&"
import style0 from "./dataBox2.vue?vue&type=style&index=0&id=fbff5254&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbff5254",
  null
  
)

export default component.exports